import { GRAFTCODE_ONBOARDING_GUIDE_OS, type GraftcodeOnboardingGuideOs } from './graftcode-onboarding-guide-os.const'

export function detectGuideOsFromUserAgent(): GraftcodeOnboardingGuideOs {
  if (typeof navigator === 'undefined') {
    return GRAFTCODE_ONBOARDING_GUIDE_OS.macos
  }

  const navigatorWithUaData = navigator as Navigator & { userAgentData?: { platform?: string } }
  const platformHint = (
    navigatorWithUaData.userAgentData?.platform ||
    navigator.platform ||
    navigator.userAgent ||
    ''
  ).toLowerCase()

  if (platformHint.includes('win')) {
    return GRAFTCODE_ONBOARDING_GUIDE_OS.windows
  }

  if (platformHint.includes('mac') || platformHint.includes('iphone') || platformHint.includes('ipad')) {
    return GRAFTCODE_ONBOARDING_GUIDE_OS.macos
  }

  return GRAFTCODE_ONBOARDING_GUIDE_OS.linux
}
